import { requestV2 } from '../common/utils';
export const getMetroApi = (params) => requestV2({
    url: '/metro/map',
    method: 'GET',
    params,
});
